<template>
  <header class="header-global">
    <base-nav class="navbar-main" type="" effect="light" expand>
      <nuxt-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img class="myuse-image" src="~assets/images/logo.svg" alt="logo" />
      </nuxt-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand">
          <nuxt-link to="/">
            <img src="~assets/images/brand/myuse_caps.png" />
          </nuxt-link>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center nav-inline-gap" slot-scope="{closeMenu}">
        <li
          v-for="(item, index) in content.links"
          :key="'link-' + index"
          class="nav-item"
          :class="[
            item.link.replace('/', ''),
            { cta: item.title === 'Find Support' } // only the CTA slides to the far right
          ]"
        >
          <nuxt-link
            :to="item.link"
            :title="item.alt"
            @click.native="closeMenu"
            :class="[
              'nav-link',
              'nav-link-icon',
              item.title === 'Find Support' ? 'btn btn-outline-primary btn-round px-4 py-2' : ''
            ]"
          >
            <span class="nav-link-inner--text mx-2">{{ item.title }}</span>
          </nuxt-link>
        </li>
      </ul>
    </base-nav>
  </header>
</template>

<script>
import BaseNav from '~/components/argon/BaseNav'
import CloseButton from '~/components/argon/CloseButton'

export default {
  components: { BaseNav, CloseButton },
  data () { return { year: new Date().getFullYear() } },
  computed: {
    content () { return this.$store.state.nav.data }
  }
}
</script>

<style scoped>
.myuse-image { height: 30px }

/* Explicit, consistent horizontal spacing for all nav items */
.nav-inline-gap {
  display: flex;
  align-items: center;
  gap: 36px;                  /* controls spacing between links */
}
.nav-inline-gap .nav-item {   /* neutralize any inherited margins */
  margin: 0 !important;
}
/* push only the CTA (“Find Support”) to the far right on large screens */
@media (min-width: 992px) {
  .nav-inline-gap .nav-item.cta {
    margin-left: auto !important;
  }
}

/* keep the CTA visually tight in the navbar */
.navbar .btn.btn-outline-primary { line-height: 1.1; }
</style>
